import { render, staticRenderFns } from "./RsNonConformity.vue?vue&type=template&id=55f4de1b&scoped=true&"
import script from "./RsNonConformity.vue?vue&type=script&lang=js&"
export * from "./RsNonConformity.vue?vue&type=script&lang=js&"
import style0 from "./RsNonConformity.vue?vue&type=style&index=0&id=55f4de1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f4de1b",
  null
  
)

export default component.exports